import './FeatureCarousel.css';

const FeatureCarousel = () => {
  const features = [
    "Sourcing from 100+ sites",
    "Built for VC + B2B sourcing",
    "Discover projects days after they begin",
    "Hands-off CRM Integration",
    "Intelligent, personal outbound generation"
  ];

  // Duplicate features for seamless infinite scroll
  const allFeatures = [...features, ...features];

  return (
    <div className="feature-carousel">
      <div className="feature-carousel-track">
        {allFeatures.map((feature, index) => (
          <div
            key={index}
            className="feature-carousel-item"
          >
            <span className="feature-carousel-checkmark">✓</span>
            <span className="feature-carousel-text">{feature}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeatureCarousel;
